import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/providers/navigation.service';

@Component({
  selector: 'sm-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  constructor(private _navService: NavigationService) { 
    this._navService.hideSidebarAndNav = false;
  }

  ngOnInit(): void {
  }

}
